import React, { Component } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Configure
} from 'react-instantsearch-dom';
import AutoComplete from './AutoComplete';
import { view } from 'react-easy-state';
import Store from '../store/store';
import '../App.css';
import DispMap from '../utils/dispMap';
import { withTranslation } from 'react-i18next';
import { ALGOLIA_ID, ALGOLIA_KEY, ALGOLIA_PREST_IDX } from '../config/algolia';


const searchClient = algoliasearch(
  ALGOLIA_ID,
  ALGOLIA_KEY
);

class PrestSearch extends Component {
  state = {
    query: '',
  };

  onSuggestionSelected = (_, { suggestion }) => {
    const { setPrestazione } = Store;
    const { idx } = this.props;

    setPrestazione({
      idx,
      id: suggestion.post_id,
      name: suggestion.post_title,
      disponibilita: DispMap[suggestion.disponibilita],
      preparazione: suggestion.link_preparazione,
      popup: suggestion.popup,
      richiesta: suggestion.richiesta
    });
    
    this.setState({
      query: suggestion.post_title,
    });

  };

  onSuggestionCleared = () => {
    this.setState({
      query: '',
    });
  };

  render() {
    const { t } = this.props;
    
    return (
      <div className="kfpr-input kfpr-input-big">
        <label>{t("Cerca una prestazione")}</label>
        <span className="kfpr-open-elenco">
            {t("se preferisci cerca in")}&nbsp;
            <div role="button" className="kfpr-link">
              {t("elenco")}
            </div>
        </span>
        <InstantSearch 
          indexName={ALGOLIA_PREST_IDX} 
          searchClient={searchClient}
          >

          <Configure hitsPerPage={4} />
          <AutoComplete
            onSuggestionSelected={this.onSuggestionSelected}
            onSuggestionCleared={this.onSuggestionCleared}
          />
        </InstantSearch>
        <div className="kfpr-onlylist-alert">
          {t("Si ricorda all’utenza che le prestazioni prenotabili dal CUP sono esclusivamente quelle presenti nell’elenco")}
        </div>
      </div>

        
    );
  }
}


export default withTranslation()(view(PrestSearch));
